import { useQuery } from '@tanstack/react-query';
import {
  ChangeOverviewDto,
  OverviewStepDto,
  OverviewWorkflowDto,
} from 'src/api/FiretrolApiClient';
import { changesOverviewApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export type { ChangeOverviewDto, OverviewStepDto, OverviewWorkflowDto };

export function useChangesOverview() {
  return useQuery({
    queryKey: queryKeys.changes.overview(),
    queryFn: ({ signal }) =>
      changesOverviewApiClient.getChanges(toCancelToken(signal)),
    meta: {
      errorContext: 'changes overview',
    },
  });
}
